//import {USERLIST} from '../actions';
import {findIndex} from 'lodash';

let namespace = 'clientpending_';

const initialState = {
	  data:[],
	  dataLoading: true,
	  dataFetchProps: {order:[['id','desc']],
		  include:[{model:'client_legal_person',as:'m_clientLegalPerson',attributes:['req_no','bank_id','msg_id','auth_time','mobile_no','user_name','open_id','last_client_id']}],
		  status:'待批准'},
      modalVisible: false,
	  modalType: 'create',

	  uploadModalVisible: false,
	  selectedRow: {},
	  selectedRowIndex: -1,
	  selectedRows: [],
      selectedRowKeys: [],
	  pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 5,
		  pageSize:5,
		  current: 1,
		},


}

export default function(state=initialState, action) {
  switch (action.type) {
    case namespace+"forcedUpdate": {

      return {
        ...state,
        ...action.payload
      }
    }
	case namespace+"updateDataById": {

		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		newData[selectedRowIndex] = {...newData[selectedRowIndex], ...action.payload.data}

		return {...state, selectedRow: action.payload.data, data: newData}
	}

	case namespace+"deleteDataById": {

		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		let i = selectedRowIndex ? selectedRowIndex : findIndex(newData, {id: id})
		newData.splice(i,1)

		return {...state, data: newData}
	}

	case namespace+"addOneRowData": {

		return {...state, data: [action.payload.data, ...state.data]}
	}

	case namespace+"RemoveDataByIndex": {

		let newData = state.data;
		let {selectedRowIndex} = action.payload
		newData.splice(selectedRowIndex,1)

		return {...state, data: newData}
	}

    default:
    return state;

  }



}
